import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CockpitProcess } from '@apps/file-process/file-process.state';

@Component({
  selector: 'app-process-widget-table-cell',
  templateUrl: './process-widget-table-cell.component.html',
  styleUrls: ['./process-widget-table-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProcessWidgetTableCellComponent {
  @Input() customerSpaceId!: string;
  @Input() process!: CockpitProcess;
}
